import { render, staticRenderFns } from "./CategoryCardAttributes.vue?vue&type=template&id=7b974f13&scoped=true"
import script from "./CategoryCardAttributes.vue?vue&type=script&lang=ts"
export * from "./CategoryCardAttributes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b974f13",
  null
  
)

export default component.exports